<template>
  <div>
    <v-card class="elevation-2">
      <v-card-text class="pa-0">
        <v-list-item>
          <v-list-item-avatar>
            <v-img
              v-if="userdata && userdata.profilePhoto"
              contain
              :src="userdata.profilePhoto"
            ></v-img>
            <v-img v-else contain src="@/assets/images/No-Photo.jpg"></v-img>
            <!-- <v-img src="@/assets/images/No-Photo.jpg"></v-img> -->
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              {{
                userdata && userdata.firstName
                  ? `${userdata.firstName} ${userdata.lastName}`
                  : ""
              }}
            </v-list-item-title>
            <v-list-item-title class="font-weight-medium">
              <span class="font-weight-light text--secondary text-caption">
                {{ readableDateFormat }}
              </span>

              <v-tooltip top v-if="comment.is_modified === true">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-if="comment.is_modified === true"
                    class="font-weight-light text--secondary text-caption pl-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    ({{ $t("lblEdited") }})
                  </span>
                </template>
                <span>{{ lastUpdatedFormat }}</span>
              </v-tooltip>
            </v-list-item-title>
            <div
              v-if="comment.is_deleted !== true"
              v-html="comment.comment"
            ></div>
            <div v-else>{{ $t("agenda.msgCommentDeleted") }}</div>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text
        class="py-0"
        v-if="
          (comment.documents && comment.documents.length > 0 && comment.is_deleted !== true) || isPermitted
        "
      >
        <v-list>
          <v-list-item
            style="min-height: 30px; height: 30px; padding: 0px"
            class="py-0"
          >
            <v-list-item-content>
              <v-list-item-title
                v-if="
                  comment.documents && comment.documents.length > 0 && comment.is_deleted !== true
                "
                @click="show = !show"
                class="cursor-pointer"
              >
                <v-icon color="primaryDark lighten-1">mdi-file-multiple</v-icon>
                {{ comment.documents.length }} file(s)
                <v-icon right v-if="show">mdi-chevron-up</v-icon>
                <v-icon right v-else>mdi-chevron-down</v-icon>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="isPermitted">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="primaryDark"
                      width="24"
                      min-width="24"
                      class="mr-2"
                      @click="editComment"
                    >
                      <v-icon size="16" color="#fff"> mdi-pencil</v-icon>
                    </a-btn>
                  </template>
                  <span> {{ $t("agenda.commentEditBtn") }} </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <a-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="primaryDark"
                      width="24"
                      min-width="24"
                      @click="deleteComment"
                    >
                      <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                    </a-btn>
                  </template>
                  <span> {{ $t("agenda.commentDeleteBtn") }} </span>
                </v-tooltip>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-expand-transition>
      <div
        v-show="show"
        v-if="(comment.documents && comment.documents.length > 0) && comment.is_deleted !== true"
      >
        <v-divider></v-divider>
        <v-card elevation="1" class="pa-2">
          <v-list dense v-if="comment.documents && comment.documents.length > 0" class="file-list">
            <v-list-item
              v-for="(file, index) in comment.documents"
              :key="`d-list-${index}`"
              link
              :class="[file.formData ? 'cursor-default' : '']"
              style="min-height: 35px; height: 35px"
            >
              <v-list-item-avatar @click="documentDownload(file)">
                <v-icon>{{ getFileIcon(file.name) }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content @click="documentDownload(file)">
                <v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        class="body-m primary--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ file.name }}
                      </span>
                    </template>
                    <p class="ma-0">
                      {{ $t("lblFileName") }} : {{ file.name }}
                    </p>
                    <p class="ma-0" v-if="file.size">
                      {{ $t("lblFileSize") }} :
                      {{ formatBytes(file.size) }}
                    </p>
                    <p class="ma-0" v-if="file.lastModified">
                      {{ $t("lblLastModifiedTime") }} :
                      {{ convertIntlDateFormat(file.lastModified) }}
                    </p>
                  </v-tooltip>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      icon
                      color="neutralGray1"
                      right
                      @click="documentDownload(file)"
                      v-bind="attrs"
                      v-on="on"
                      ><v-icon size="18"> mdi-download</v-icon></v-btn
                    >
                  </template>
                  <span>{{ $t("agenda.tipSaveDoc") }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </div>
    </v-expand-transition>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import {
  formatBytes,
  convertIntlDateFormat,
  openDocument,
  findDay,
} from "../../../utils/util";
import { fileIcons } from "../../../utils/constant";
import meetingService from "@/api/meetingService";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import Loader from "@/components/Loader.vue";
export default {
  name: "ChatTimelineCard",
  components: {
    ConfirmDialog,
    MessageSheet,
    Loader,
  },
  props: {
    comment: {
      type: Object,
      default: true,
    },
  },
  data: function () {
    return {
      show: true,
      displayMessage: false,
      message: "",
      messageType: "",
    };
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
      deletedUserList: (state) => state.meeting.deletedUserList,
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    userdata() {
      if (this.comment && this.comment.firstName) {
        return {
          firstName: this.comment.firstName,
          lastName: this.comment.lastName,
          profilePhoto: this.comment.profilePhoto,
        };
      }
      let localUserList = [...this.userList];
      localUserList = localUserList.concat(this.deletedUserList);
      const result = localUserList.find(
        (item) => item.id == this.comment.created_by
      );
      return result;
    },
    readableDateFormat() {
      const created_at = this.comment.created_at;

      const olderDate = new Date(created_at);
      const currentDate = new Date();

      const diff = olderDate - currentDate;
      const formatter = new Intl.RelativeTimeFormat("en", {
        numeric: "always",
      });
      const readableDate = formatter.format(Math.round(diff / 86400000), "day");
      return readableDate;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    lastUpdatedFormat() {
      if (this.comment.updated_at) {
        return findDay(this.comment.updated_at, this.selectedLang);
      }
      return "";
    },
    isPermitted() {
      return (
        this.comment.created_by === this.$auth.user.user_id &&
        this.comment.is_deleted !== true
      );
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
      deletechatmessage: "agenda/deletechatmessage",
      listMeetingChatComments: "agenda/listMeetingChatComments",
    }),
    formatBytes,
    convertIntlDateFormat,
    editComment() {
      this.$emit("editComment", this.comment);
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async ConfirmDelete() {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage")
        )
      ) {
        return true;
      }
    },
    async deleteComment() {
      const answer = await this.ConfirmDelete();
      if (answer) {
        try {
          const response = await this.deletechatmessage(
            {'id' : this.comment.id, 'master_message_id': this.comment.master_message_id}
          );
          
          if (response.status) {
            this.showMessageSheet(
              this.$t("chat.messageDeleteSuccessMessage"),
              "success"
            );
          } else {
            this.showMessageSheet(this.$t("agenda.commentFaildMsg"), "error");
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async documentDownload(item) {
      let loader = this.$localLoader.show()
      try {
        const params = {
          documentId: item.documentId,
          filename: item.name,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        this.downloadMessage(url, item.name);
        //openDocument(url, item.name);
        this.$localLoader.hide(loader);
      } catch (error) {
        this.$localLoader.hide(loader);
        console.error(error);
      }
    },
    downloadMessage(url, name) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    getFileIcon(filename) {
      let strArr = filename.split(".");
      let arrlength = strArr.length;
      if (arrlength > 0) {
        return fileIcons[strArr[arrlength - 1].toLowerCase()] || "mdi-file";
      }
      return "mdi-file";
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  box-shadow: none;
}
</style>